import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './FAQ.scss';

const FAQ = ({ setProductPosition }) => {
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      setProductPosition('FAQ');
    }
  }, [inView, setProductPosition]);

  return (
    <div id="fourth" className="fAQ">
      <div className="FAQTitle">FAQ</div>
      <div className="Q">Q. 어떤 난로에서 사용이 가능한가요?</div>
      <div className="A">
        A. TUF는 대류형 등유난로에서 사용 가능한 제품입니다.
      </div>
      <div className="Q">
        Q. 상판에 구멍이 있는 토요토미 DC-100 제품에서 사용 가능한가요?
      </div>
      <div className="A">
        A. TUF 에는 DC-100 모델 상판 구멍의 대류열을 하단으로 내려주도록
        설계되어 있어, 문제 없이 사용 가능합니다.
      </div>
      <div className="Q">Q. 부스팅 스커트는 꼭 필요한가요?</div>
      <div className="A" ref={ref}>
        A. 스커트 없이 TUF를 사용하셔도 제품 구동과 서큘레이션 기능은 문제가
        없습니다. 다만 스커트 사용 시, 빠른 구동과 높은 회전 속도 및 넓은
        방사각으로 인해 내부 공간이 넓은 텐트에서 사용 시 스커트 거치를
        권장드립니다.
      </div>
      <div className="Q">Q. 난로의 상부망을 제거하고 사용해야 하나요?</div>
      <div className="A">
        A. 그렇습니다. 난로 상판과의 접촉을 통한 전도열로 작동하는 원리이므로,
        상판을 제거한 후 사용하셔야 합니다.
      </div>
      <div className="Q">Q. 화목 난로에서도 사용 가능한가요?</div>
      <div className="A">
        A. 화목 난로는 등유난로보다 표면 온도가 높아, 소자의 허용 온도 한계치를
        초과할 수 있습니다. 따라서, 화목 난로에서의 사용은 불가합니다.
      </div>
      <div className="Q">
        Q. 난로에 올려 놓고 어느 정도의 시간이 지나야 돌아가나요?
      </div>
      <div className="A">
        A. 난로가 충분히 뜨거워지고 난 후에 TUF 를 올리면 일반적으로 2분 가량
        이내에 회전이 시작되나, 사용 환경에 따라 1~2 분 정도의 편차가 생기거나
        초기 구동이 원활하지 않을 수 있습니다. 이 경우 가볍게 바람을 불어 팬을
        살짝만 회전시키면 정상적으로 구동됩니다.
      </div>
      <div className="Q">Q. A/S 정책은 어떻게 되나요?</div>
      <div className="A">
        A. TUF 무동력팬 제품은 2년의 무상 수리 기간을 제공합니다. 단, 사용자
        과실로 인한 고장 또는 임의 분해 시에는 무상 수리가 불가합니다.
      </div>
      <div className="Q">Q. 제품 내 소자의 수명은 어느 정도인가요?</div>
      <div className="A">
        A. 설계된 정상 작동 환경에서 소자의 수명은 약 3만 시간 가량입니다.
        다양한 사용 환경을 고려 시 약 3~4년 이상 사용이 가능합니다. 다만 예상
        수명이 보증 기간을 의미하는 것은 아닙니다.
      </div>

      <div className="CautionTitle">사용상의 주의 사항</div>
      <div className="CautionMain">
        제품 사용 시 안전 사고를 방지하기 위하여 다음 사항을 반드시 지켜 주시기
        바랍니다.
      </div>
      <ul className="Caution">
        <br />
        <br />
        <li>
          본 제품은 등유난로 상판에 올려 사용하는 난방 보조 용도의 제품입니다.
          정해진 용도 외 임의 목적의 사용을 금합니다.
        </li>

        <li>
          반드시 난로가 점화된 후 20~30분 정도의 충분한 시간이 지난 후에 난로
          상판 위에 거치하십시오.
        </li>
        <li>절대로 TUF를 올려놓은 상태에서 난로를 점화하지 마십시오.</li>
        <li>난로 상부의 안전망을 제거한 상태로 TUF를 올려 주십시오.</li>
        <li>
          본 제품은 난로 상판과 직접 접촉하여 작동하는 제품입니다. 본체 하단
          접촉면과 난로 상판 사이, 열전달을 방해는 안전망, 이물질 등이 있으면
          제품 고장의 원인이 됩니다.
        </li>
        <li>
          표면 온도가 섭씨 350도를 초과하는 열원(화목난로 등)에는 사용하지
          마십시오.
        </li>
        <li>
          팬의 회전으로 인해, 흔들리는 바닥에서 사용 시 제품과 난로에 진동이
          발생할 수 있습니다. 꼭 평평한 바닥에서 사용해 주십시오
        </li>
        <li>
          TUF를 난로 위에 올린 후 회전이 시작되어 본체가 충분히 냉각되기
          전까지는 TUF의 본체를 맨손으로 만지지 마십시오.
        </li>
        <li>
          제품 정상 작동 시, 팬의 상단 부분은 뜨겁지 않습니다. 제품 작동 후 5분
          이상 경과 후에도 상부망이 뜨겁거나 회전이 시작되지 않는다면, 난로에서
          내려 충분히 식힌 후 사용하시기 바랍니다. (이 경우, 반드시 내열장갑을
          착용하십시오!)
        </li>
        <li>
          제품을 난로 위에 거치한 후 정상 회전 속도에 도달할 때 까지는 매우
          뜨겁습니다. 충분한 회전 속도에 도달하기 전 제품을 난로에서 내려놓을
          때는 반드시 내열장갑 등을 사용하여 신체 일부가 닿지 않도록 주의해
          주십시오.
        </li>
        <li>
          작동 중인 TUF의 핫플레이트와 부스팅 스커트는 매우 뜨거우니 절대로
          만지지 마십시오.
        </li>
        <li>
          제품 상단 흡기구에 공기의 유입을 방해하는 이물질을 올려 놓지 마십시오.
        </li>
        <li>
          사용이 끝난 TUF는 반드시 녹지 않는 바닥에 올려 놓고 충분한 시간 동안
          식혀 주시기 바랍니다. 절대로 열에 녹는 소재의 바닥에 올려놓지
          마십시오.
        </li>
      </ul>

      <div className="CautionTitle">취급 시 주의 사항</div>
      <div className="CautionMain">
        제품 취급 시 아래 사항을 반드시 지켜 주시기 바랍니다.
      </div>
      <ul className="Caution">
        <br />
        <br />
        <li>
          사용 및 보관 시, 수분이나 유분에 노출되지 않는 건조한 곳에 보관하여
          주십시오.
        </li>
        <li>
          제품 내부에 충격에 민감한 소자가 내장되어 있습니다. 따라서 제품에 강한
          충격이 가해지지 않도록 주의해 주십시오.
        </li>
        <li>
          제품을 케이스에 넣고 운반 시, 반드시 케이스 하단을 잡고 이동해
          주십시오. 케이스 뚜껑을 잡고 운반 시, 본체가 떨어져 고장의 원인이
          됩니다.
        </li>
        <li>
          TUF를 케이스에 보관 시, 케이스에 물기가 없는 상태로 보관하십시오.
        </li>
        <li>
          TUF 본체를 임의로 분해하지 마십시오. 임의 분해 시 A/S 가 불가할 수
          있습니다.
        </li>
        <li>TUF 본체에 열에 잘 녹는 소재의 부착물을 가급적 붙이지 마십시오.</li>
      </ul>
    </div>
  );
};

export default FAQ;
